export default "__VITE_ASSET__DL2kmt0E__"